import styled from "styled-components";
import { colors } from "../../utils";
import { TextView } from "@components";
import { device } from "../../utils/device";

export const Container = styled.div`
  display: grid;
  min-height: 100vh;
  width: 100vw;
  grid-template-columns: 40% 60%;
  overflow-x: hidden;

  @media ${device.mobilePortrait},
    ${device.mobileLandscape},
    ${device.tabletPortrait} {
    grid-template-columns: 1fr;
  }
`;

export const LeftView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${({ isBackgroundGradient }) =>
    isBackgroundGradient
      ? "conic-gradient(from 180deg at 50% 50%, #F5EEDE -41.73deg, #F7FED5 53.81deg, #CCFEFF 133.87deg, #FDCFFE 244.39deg, #F5EEDE 318.27deg, #F7FED5 413.81deg), linear-gradient(180deg, rgba(255, 255, 255, 0.9) 21.66%, rgba(255, 255, 255, 0.558) 100%)"
      : "white"};
`;

export const RightView = styled.div`
  min-height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;

  @media ${device.mobilePortrait},
    ${device.mobileLandscape},
    ${device.tabletPortrait} {
    display: none;
  }
`;

export const MobileImage = styled.img`
  width: 100%;
  max-width: 550px;
  margin-bottom: 40px;
  margin-top: 20px;

  ${({ isTablet = false }) =>
    isTablet &&
    `
    position: absolute;
    max-width:100%;
    top:40px;
  `}
`;
export const IyugaImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

export const ContentView = styled.div`
  width: 28vw;
  min-width: 350px;
  padding: 40px 0px;
  max-width: 420px;

  @media ${device.mobilePortrait} {
    width: 80vw;
    min-width: 10px;
    margin-top: -60px;
    max-width: 600px;
  }

  @media ${device.mobileLandscape} {
    width: 50vw;
    max-width: 600px;
  }

  @media ${device.tabletPortrait} {
    width: 80vw;
    max-width: 600px;
  }
`;

export const LogoView = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media ${device.mobilePortrait},
    ${device.mobileLandscape},
    ${device.tabletPortrait} {
    display: none;
  }
`;

export const Logo = styled.img`
  width: 10vw;
  min-width: 120px;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  input::placeholder {
    color: #212529;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const PasswordIcon = styled.img`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-60%);
  cursor: pointer;
`;

export const Error = styled(TextView)`
  color: ${colors.error};
  margin: 5px 0px 5px 0px;
  text-align: left;
  display: flex;
  gap: 5px;
`;

export const HelperText = styled(TextView)`
  color: #565556;
  font-size: 12px;
  font-weight: 400;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Checkbox = styled.input`
  margin-right: 5px;
  height: 16px !important;
  width: 16px !important;
  accent-color: ${colors.PrimaryPurple} !important;
  cursor: pointer;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
`;

export const Line = styled.div`
  border-top: 1px solid ${colors.lightBorder};
  margin: 0 auto;
  width: 45%;
`;

export const BottomView = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 280px;
  margin: auto;
  margin-top: 20px;
`;

export const Link = styled.a`
  color: blue;

  &:hover {
    color: ${colors.primary};
  }
`;

export const SocialBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 12px;
  width: 80%;
  margin: auto;
  margin-bottom: 20px;
`;

export const SocialItem = styled.div`
  background-color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8ecf4;
  height: 54px;
  max-width: 100px;
  cursor: pointer;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
`;

export const Message = styled(TextView)`
  color: #565556;
  font-size: 16px;
  font-weight: ${({ weight }) => weight || 500};
  text-align: center;
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  padding: 8px 10px 8px 10px;
  margin-bottom: 8px;
  border: 1px solid #ced4da;
  justify-content: space-between;
  background-color: white;

  @media ${device.mobilePortrait},
    ${device.mobileLandscape},
    ${device.tabletPortrait} {
    background-color: white;
  }

  .react-datepicker__input-container input {
    font-size: 14px !important;
    font-weight: 400 !important;
    font-family: "DM Sans", sans-serif !important;
    color: #212529 !important;
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
  }

  ::placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    font-family: "DM Sans", sans-serif !important;
  }
`;

export const TermsAndConditions = styled.div`
  align-items: center;
`;

export const TermsAndConditionsText = styled(TextView)`
  color: #212529;
  font-size: 14px;
  font-weight: 400;
`;

export const TermsAndConditionsLink = styled.span`
  color: #8f38ef;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
`;
